export const STATIC_PAGES = {
  VE_CHUNG_TOI: 've-chung-toi',
  CHINH_SACH_DIEU_KHOAN: 'chinh-sach-dieu-khoan',
  QUY_CHE_HOAT_DONG: 'quy-che-hoat-dong',
};

export type StaticPageKey = keyof typeof STATIC_PAGES;
